<template>
    <div class="cabinet-content-wrap">
        <p v-if="loading" class="mt-3">Loading...</p>

        <div v-if="!error && !loading">
            <header class="cabinet-header flex flex-align-center">
                <a
                    href="#"
                    class="cabinet-btn--back cabinet-btn--back-list"
                    @click.prevent="$router.go(-1)"
                ></a>
                <h1 class="h1 cabinet-title">Заказ №{{ order.OrderNo }}</h1>
            </header>

            <section v-if="Object.keys(order).length" class="v2-retailer-order">
                <div class="v2-retailer-order__top">
                    <div class="v2-retailer-order__top-left">
                        <div class="v2-retailer-order__top-cell">
                            <div class="v2-retailer-order__top-key">
                                Оформлен
                            </div>
                            <div class="v2-retailer-order__top-val">
                                {{
                                    getFormattedDate(
                                        order.RegDate,
                                        'DD MMMM YYYY'
                                    )
                                }}
                            </div>
                        </div>
                        <div class="v2-retailer-order__top-cell">
                            <div class="v2-retailer-order__top-key">
                                Покупатель
                            </div>
                            <div class="v2-retailer-order__top-val">
                                {{ orderContacts.Name }}
                            </div>
                            <div class="v2-retailer-order__top-val">
                                {{ orderContacts.Phone }}
                            </div>
                            <div class="v2-retailer-order__top-val">
                                {{ orderContacts.Email }}
                            </div>
                            <div
                                v-if="order.retailer"
                                class="v2-retailer-order__top-val"
                            >
                                {{ order.retailer.company_name }}
                            </div>
                        </div>
                    </div>
                    <div class="v2-retailer-order__top-right">
                        <div class="v2-retailer-order__top-detail">
                            <div
                                v-for="group in orderItems"
                                :key="group.BrandID"
                                class="v2-retailer-order__top-val"
                            >
                                {{ group.BrandName }},
                                {{ getItemsCountByBrand(group.BrandID) }} шт,
                                {{
                                    getFormattedNum(
                                        getItemsPriceByBrand(
                                            group.BrandID
                                        ).toFixed(2)
                                    )
                                }}
                                Р
                            </div>
                        </div>
                        <div class="v2-retailer-order__top-total">
                            Итого: ~
                            {{
                                order.TotalPrice
                                    ? getFormattedNum(
                                          parseFloat(order.TotalPrice).toFixed(
                                              2
                                          )
                                      )
                                    : '0'
                            }}
                            Р
                        </div>
                        <button
                            type="button"
                            class="cabinet-btn"
                            @click="repeatOrder"
                        >
                            Повторить заказ
                        </button>
                    </div>
                </div>
                <div class="v2-retailer-order__body">
                    <div
                        v-for="brand of order.ItemsByBrand"
                        :key="brand.BrandID"
                        class="v2-retailer-order__brand"
                    >
                        <router-link
                            :to="`/account/brands/${brand.BrandID}`"
                            class="v2-retailer-order__brand-title"
                        >
                            {{ brand.BrandName }}
                        </router-link>
                        <order-product-item
                            v-for="product of brand.Items"
                            :key="product.ItemID"
                            :product="product"
                            :brand="brandInfo(brand.BrandID)"
                            @onClickToRequestAccess="openRequestAccessModal"
                        />
                    </div>
                </div>
            </section>

            <request-access-modal
                :is-open="isOpenRequestAccessBrandModal"
                :brand="requestAccessBrand"
                @onConfirm="sendBrandAccessRequest"
                @onClose="closeRequestAccessModal"
            />
        </div>

        <div v-if="!loading && error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button type="button" class="cabinet-btn" @click="getOrder">
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import getFormattedDate from '../../../utils/getFormattedDate'
import getFormattedNum from '../../../utils/getFormattedNum'
import modal from '../../../mixins/modal'

import OrderProductItem from '@/components/Cabinet/Retailer/Orders/OrderProductItem'
import RequestAccessModal from '@/components/Cabinet/Retailer/Brands/RequestAccessModal'

export default {
    name: 'RetailerOrderID',
    components: { OrderProductItem, RequestAccessModal },
    mixins: [modal],
    data() {
        return {
            order: {},
            orderContacts: {},
            orderItems: [],
            orderID: this.$route.params.id,
            requestAccessBrand: null,
            error: false,
            loading: true,
            isOpenRequestAccessBrandModal: false
        }
    },
    computed: {
        ...mapState('retailerBrand', ['brands']),
        itemsTotalCount() {
            let totalCount = 0

            totalCount = this.orderItems.reduce((acc, brand) => {
                return (
                    acc +
                    brand.Items.reduce((brandAcc, item) => {
                        return brandAcc + parseInt(item.pivot.Quantity)
                    }, 0)
                )
            }, 0)

            return totalCount
        },
        itemsTotalSum() {
            let totalCount = 0

            totalCount = this.orderItems.reduce((acc, brand) => {
                return (
                    acc +
                    brand.Items.reduce((brandAcc, item) => {
                        return (
                            brandAcc +
                            parseInt(item.pivot.Quantity) *
                                (parseInt(item.Price) || 0)
                        )
                    }, 0)
                )
            }, 0)

            return totalCount
        }
    },
    created() {
        this.getOrder()
        this.getBrands({ all: 1 })
    },
    methods: {
        ...mapActions('orders', {
            repeatOrderAction: 'repeatOrder'
        }),
        ...mapActions('retailerBrand', ['getBrands', 'requestAccessToBrand']),
        getFormattedDate,
        getFormattedNum,
        getOrder() {
            this.loading = true
            this.$Progress.start()

            return this.$axios
                .get(`/retailer/orders/${this.orderID}`)
                .then(({ data }) => {
                    this.error = false
                    this.order = data
                    this.orderContacts = data.Contacts
                    this.orderItems = data.ItemsByBrand
                })
                .finally(() => {
                    this.loading = false
                    this.$Progress.finish()
                })
                .catch(() => {
                    this.error = true
                })
        },
        repeatOrder() {
            this.$Progress.start()
            this.repeatOrderAction(this.orderID)
                .then(() => {
                    this.$Progress.finish()

                    this.$notify({
                        type: 'success',
                        title: `Изделия из заказа от ${getFormattedDate(
                            this.order.RegDate,
                            'DD MMMM YYYY'
                        )} добавлены в корзину`
                    })
                })
                .catch(() => {
                    this.$Progress.fail()
                })
        },
        getItemsCountByBrand(brandId) {
            return this.orderItems
                .find(product => product.BrandID === brandId)
                .Items.reduce(
                    (acc, item) => acc + parseInt(item.pivot.Quantity, 10),
                    0
                )
        },
        getItemsPriceByBrand(brandId) {
            return this.orderItems
                .find(product => product.BrandID === brandId)
                .Items.reduce(
                    (acc, item) =>
                        acc +
                        parseInt(item.pivot.Quantity) *
                            (parseFloat(item.pivot.Price) || 0),
                    0
                )
        },
        brandInfo(id) {
            return this.brands.find(brand => brand.BrandID == id) || {}
        },
        openRequestAccessModal(brandData) {
            this.requestAccessBrand = brandData
            this.isOpenRequestAccessBrandModal = true
        },
        closeRequestAccessModal() {
            this.requestAccessBrand = null
            this.isOpenRequestAccessBrandModal = false
        },
        sendBrandAccessRequest(brand) {
            if (this.isDemoUserMode()) return

            this.requestAccessToBrand(brand.BrandID).then(() => {
                this.getBrands({ all: 1 })

                this.$notify({
                    type: 'success',
                    text: `Запрос доступа к скрытым изделиям бренда “${brand.BrandName}” отправлены`
                })
            })

            this.requestAccessBrand = null
            this.isOpenRequestAccessBrandModal = false
        }
    }
}
</script>
